module.exports = __webpack_public_path__ + "assets/pin-orange.43d1d91038785a280f7077dac44db998.png";


//////////////////
// WEBPACK FOOTER
// ./public/images/pin/pin-orange.png
// module id = 519
// module chunks = 0